function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.5859 6.75V20.25C24.5859 21.4922 23.5781 22.5 22.3359 22.5H2.83594C1.59375 22.5 0.585938 21.4922 0.585938 20.25V6.75C0.585938 5.50781 1.59375 4.5 2.83594 4.5H6.96094L7.5375 2.95781C7.86563 2.08125 8.70469 1.5 9.64219 1.5H15.525C16.4625 1.5 17.3016 2.08125 17.6297 2.95781L18.2109 4.5H22.3359C23.5781 4.5 24.5859 5.50781 24.5859 6.75ZM18.2109 13.5C18.2109 10.3969 15.6891 7.875 12.5859 7.875C9.48281 7.875 6.96094 10.3969 6.96094 13.5C6.96094 16.6031 9.48281 19.125 12.5859 19.125C15.6891 19.125 18.2109 16.6031 18.2109 13.5ZM16.7109 13.5C16.7109 15.7734 14.8594 17.625 12.5859 17.625C10.3125 17.625 8.46094 15.7734 8.46094 13.5C8.46094 11.2266 10.3125 9.375 12.5859 9.375C14.8594 9.375 16.7109 11.2266 16.7109 13.5Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.585938 0H24.5859V24H0.585938V0Z",
  fill: "white"
})));

var SvgIcnCamera = function SvgIcnCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#FFFFFF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-camera.020f585a.svg";
export { ForwardRef as ReactComponent };